import React from 'react';
import { List, Popover, PopoverContent, PopoverTrigger, ListItem, Box, PopoverBody } from '@chakra-ui/react';
import { CreateNewTableButtonProps } from './Table.types';
import FileUploadWrapper from '../../components/ui/file/UploadWrapper';

export default function CreateNewTableButton({ children, onUpload }: CreateNewTableButtonProps) {
  const initRef = React.useRef(null);

    return (
      <Popover 
        placement="bottom-end" 
        closeOnBlur={true}
        returnFocusOnClose={true}
        initialFocusRef={initRef}
      >
        {({ onClose }) => (
          <>
          <PopoverTrigger>{children}</PopoverTrigger>
          <PopoverContent zIndex={1000} width="fit-content">
          {/* <PopoverCloseButton /> */}
            <PopoverBody>
                <List>
                  <ListItem padding="0.3rem" className='pointer'>
                    <Box fontSize="0.75rem" _hover={{ color: "blue.500" }}>
                      New table
                    </Box>
                  </ListItem>
                  <ListItem padding="0.3rem">
                    <FileUploadWrapper onUpload={(file) => { onUpload!(file); onClose()}}>
                      <Box fontSize="0.75rem" _hover={{ color: "blue.500" }}>
                        New import
                      </Box>
                    </FileUploadWrapper>
                  </ListItem>
                </List>
            </PopoverBody>
          </PopoverContent>
          </>
        )}
      </Popover>
    );
  }
  